module.exports = __webpack_public_path__ + "assets/b3fa3b9ac1383783bbffe48c85ba9653.svg";